<template>
  <div v-if="!loading" class="admin-table">
    <v-data-table
      :headers="[
        {
          title: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
      ]"
      :items="admins"
      :items-per-page="-1"
      must-sort
      sort-asc-icon="$chevron-down"
      sort-desc-icon="$chevron-up"
      :sort-by="[{ key: 'name', order: 'asc' }]"
    >
      <template #[`item.name`]="{ item }">
        <div class="w-full d-flex justify-space-between align-center name-container">
          <div class="d-flex flex-column align-start">
            <h5 class="name">
              {{ item.name }}
            </h5>
            <div class="email">
              {{ item.email }}
            </div>
          </div>
          <DpplNewButton
            v-if="showRemoveAccessButton"
            color="error"
            variant="outlined"
            :disabled="item.id === currentUserId || admins.length === 1"
            @click="$emit('removeAccess', item)"
          >
            Remove Full Access
          </DpplNewButton>
        </div>
      </template>
      <template #bottom>
        <span />
      </template>
    </v-data-table>
  </div>
  <div v-else class="admin-table">
    <v-skeleton-loader
      :loading="loading"
      width="100%"
      type="table-heading"
    />
    <v-skeleton-loader
      :loading="loading"
      width="100%"
      type="table-row"
    />
    <v-skeleton-loader
      :loading="loading"
      width="100%"
      type="table-row"
    />
    <v-skeleton-loader
      :loading="loading"
      width="100%"
      type="table-row"
    />
  </div>
</template>

<script setup>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

defineProps({
  admins: {
    type: Array,
    required: true,
  },
  showRemoveAccessButton: {
    type: Boolean,
    default: false,
  },
  sortDirection: {
    type: String,
    default: 'asc',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  currentUserId: {
    type: Number,
    default: 0,
  },
});

defineEmits(['removeAccess']);
</script>

<style scoped lang="less">
.name {
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  color: @text-darkest;
}

.email {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  color: @text-light;
}

.admin-table {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.name-container {
  padding-right: 80px;
}

:deep(thead) {
  tr {
    background: @bg-input;
    max-height: 40px !important;
    height: 40px !important;

    &:hover {
      background: @bg-input !important;
      box-shadow: none !important;
    }

    th {
      padding: 0;
      height: 40px !important;
      font-size: 12px;
      font-weight: 500;
      line-height: 150%;
    }
  }
}

:deep(tbody) {
  display: block;
  max-height: 670px !important;
  overflow-y: auto;

  tr {
    height: 64px;
    display: table;
    width: 100%;
  }
}
</style>
